<div class="system-bet-type-container">
    <div class="system-bet-type-container__content">
        <div class="system-bet-type-container__info-container">
            <div class="system-bet-type-container__info-title-container">
                <span class="system-bet-type-container__info-title"> {{ getTitle() }} </span>
                <span class="theme-info system-bet-type-container__info-icon" *ngIf="betslipInfoMessage" (click)="toggleSystemInfo()"></span>
            </div>
            <bs-info-message-container [messageId]="this.infoMessageId()">
                <bs-digital-bettype-info-popup [messages]="betslipInfoMessage" (close)="toggleSystemInfo()" />
            </bs-info-message-container>
            <bs-linear-eachway-price-button
                *ngIf="isEachWayButtonVisible$ | async"
                [isToggled]="isEachWay$ | async"
                (toggleEachWay)="toggleEachWay($event)"></bs-linear-eachway-price-button>
        </div>

        <bs-linear-container-summary
            class="system-bet-type-container__summary"
            [showOdds]="false"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [msAutomation]="systemTypeInfo.slipType.key"></bs-linear-container-summary>
    </div>
    <bs-linear-slip-errors [slipId]="slipId" [betslipType]="betslipType"></bs-linear-slip-errors>
</div>
